module.exports = __webpack_public_path__ + "img/mingbai1.2_aef339d43.png";